/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unknown-property */
import React, { useContext, useEffect, useState } from 'react'

import { RoleContext } from '../../../store/role-context-provider'
import ResponseKPI from './response-kpi'
import { responsePending, responseRequest } from './response-kpis-data'

interface KPIItem {
  colorCode?: string
  count?: string
  countClass?: string
  link?: string
  sectionCode?: number
  title?: string
}
interface Props {
  currentSection: any
  filter: any
  kpiTitle: string
  setKpiName: any
  updateKpiFilter
}
const ResponseKPIs = ({ currentSection, filter, kpiTitle, setKpiName, updateKpiFilter }: Props) => {
  const {
    isAFRCOwner,
    isANGOwner,
    isCPOwner,
    isLeadership,
    isMAJCOMOwner,
    isMPFOwner,
    isRegAFOwner,
  } = useContext(RoleContext)
  const isOwnerOrLeadership =
    isAFRCOwner ||
    isANGOwner ||
    isRegAFOwner ||
    isMPFOwner ||
    isMAJCOMOwner ||
    isCPOwner ||
    isLeadership ||
    isMAJCOMOwner

  const [data, setData] = useState<KPIItem[]>([])

  useEffect(() => {
    if (kpiTitle.toLocaleLowerCase() === 'response requested') {
      setData(responseRequest)
    }
    if (kpiTitle.toLocaleLowerCase() === 'response pending') {
      setData(responsePending)
    }
  }, [kpiTitle])

  return (
    <div className='row'>
      {data
        ?.filter((kpiItem: KPIItem) => {
          if (kpiTitle.toLocaleLowerCase() === 'response requested' && !isOwnerOrLeadership) {
            return kpiItem.sectionCode === currentSection
          } else if (kpiTitle.toLocaleLowerCase() === 'response pending' && !isOwnerOrLeadership) {
            return kpiItem.sectionCode !== currentSection
          } else if (isOwnerOrLeadership) {
            return kpiItem
          } else {
            return null
          }
        })
        .map((kpiItem: KPIItem, key) => {
          return (
            <ResponseKPI
              key={key}
              kpiItem={kpiItem}
              kpiTitle={kpiTitle}
              setKpiName={setKpiName}
              updateKpiFilter={updateKpiFilter}
              updateTotal={updateKpiFilter}
            />
          )
        })}
    </div>
  )
}
export default ResponseKPIs
